import { createReducer, on, Action } from '@ngrx/store';

import * as BrandActions from '../actions/brand.actions';
import { Brand } from '../../../shared/interfaces/brand.type';

export interface State {
    brands: Brand[];
    activeBrandId: number | null;
    loaded: boolean;
    loading: boolean;
    errorMessage: string | null;
}

export const initialState: State = {
    brands: [],
    activeBrandId: null,
    loaded: false,
    loading: false,
    errorMessage: null,
};

const brandReducer = createReducer(
    initialState,

    on(BrandActions.loadBrands, (state) => ({
        ...state,
        loading: true,
        errorMessage: null,
    })),

    on(BrandActions.loadBrandsSuccess, (state, { brands }) => ({
        ...state,
        brands,
        loaded: true,
        loading: false,
        errorMessage: null,
    })),

    on(BrandActions.loadBrandsFailure, (state, { error }) => ({
        ...state,
        loading: false,
        errorMessage: error?.message ?? 'Failed to load brands',
    })),

    on(BrandActions.setActiveBrand, (state, { brandId }) => ({
        ...state,
        activeBrandId: brandId,
    })),

    on(BrandActions.clearBrandState, () => ({ ...initialState })),
);

export function reducer(state: State | undefined, action: Action) {
    return brandReducer(state, action);
}
